/* eslint-disable multiline-ternary */
import { yupResolver } from '@hookform/resolvers/yup'
import moment from 'moment/moment'
import { Fragment, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import Select from 'react-select'
import {
  Button,
  Card,
  CardHeader,
  CardTitle,
  Col,
  Form,
  Input,
  Label,
  Row,
} from 'reactstrap'
import ResponsiveDatePickers from '../../../components/date-picker/index'
import {
  InputEmail,
  InputNumber,
  InputPhone,
} from '../../../components/inputs'
import { getTransactions, setInitialData } from '../store'
import SchemaValidations from './validations'
import { sendFiltersAdapter } from '../adapters'
import toast from 'react-hot-toast'
// import InputEmail from '../../../components/inputs'

const initialFilterProps = {
  clientCode: '',
  codeType: '',
  dteType: '',
  company: '',
  receiverEmail: '',
  receiverPhoneNumber: '',
  receiverName: '',
  startDate: moment().subtract(1, 'day'),
  endDate: null,
}

const InvoicesFilter = ({
  onFilter,
  setFilters,
  abortControllerRef,
  handleAbortFilters,
}) => {
  const [filterProps, setFilterProps] = useState(initialFilterProps)
  const [areaFilterValue, setAreaFilterValue] = useState(null)
  const dispatch = useDispatch()
  const { isPending } = useSelector((state) => state.transactions)

  // useForm
  const {
    handleSubmit,
    control,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      ...initialFilterProps,
    },
    mode: 'all',
    reValidateMode: 'onChange',
    resolver: yupResolver(SchemaValidations),
  })

  const handleClearFilters = () => {
    handleAbortFilters()
    setFilterProps(initialFilterProps)
    setAreaFilterValue(null)
    dispatch(setInitialData())
    reset()
  }

  const onSubmit = (data) => {
    // const previousDay = moment(filterProps.startDate).subtract(1, 'day')
    if (abortControllerRef.current) {
      abortControllerRef.current?.abort() // Cancelar petición activa antes de enviar una nueva
    }

    abortControllerRef.current = new AbortController() // Crear nuevo AbortController
    const filter = {
      ...data,
      codeType: filterProps.codeType,
      startDate: filterProps.startDate,
      endDate: filterProps.endDate,
    }

    if (!filterProps.startDate) delete filter.startDate
    if (!filterProps.endDate) delete filter.endDate

    const hasDate = filterProps.startDate || filterProps.endDate
    const hasOtherFields =
      data.receiverEmail ||
      data.receiverPhoneNumber ||
      data.receiverName ||
      data.clientCode

    if (hasDate && !hasOtherFields) {
      toast.error(
        'Si ingresa una fecha, debe completar al menos un campo adicional.'
      )
      return
    }
    // onFilter(filter)
    const newFilters = sendFiltersAdapter(filter)
    if (Object.keys(newFilters).length === 0) return
    setFilters(newFilters)
    dispatch(
      getTransactions({
        filters: newFilters,
        page: 0,
        size: 20,
        signal: abortControllerRef.current.signal,
      })
    )
  }

  /*useEffect(() => {
    if (consultOnce.current === 1) {
      onSubmit(initialFilterProps)
      consultOnce.current++
    }
    // console.log(consultOnce.current)
  }, [])*/

  return (
    <Fragment>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Card>
          <CardHeader className="flex-md-row flex-column align-md-items-center align-items-start border-bottom">
            <CardTitle tag="h4">
              Documentos con error - Filtro de Búsqueda
            </CardTitle>
          </CardHeader>
          {/* <Row className="mx-0" style={{ paddingTop: '2%', paddingLeft: '5%' }}>
            <Col md="5" sm="12">
            <InputText
                label={"Sociedad"}
                errors={errors}
                options={{
                  control,
                  id: 'company',
                  name: 'company',
                  disabled: true
                }}
              />
            </Col>
          </Row> */}
          <Row
            className="mx-0"
            style={{ paddingTop: '2%', paddingLeft: '5%' }}
          >
            <Col
              md="5"
              sm="12"
            >
              <InputEmail
                label="Correo Electrónico"
                errors={errors}
                control={control}
                options={{
                  id: 'receiverEmail',
                  name: 'receiverEmail',
                }}
              />
            </Col>

            <Col
              md="5"
              sm="12"
            >
              <Label for="receiverName">Nombre de cliente</Label>
              <Controller
                name="receiverName"
                control={control}
                render={({ field }) => (
                  <Input
                    id="receiverName"
                    type="text"
                    {...field}
                    invalid={!!errors.receiverName}
                  />
                )}
              />
              {errors.receiverName && (
                <div className="text-danger">
                  {errors.receiverName.message}
                </div>
              )}
            </Col>
          </Row>
          <Row
            className="mx-0"
            style={{ marginBlock: '1%', paddingLeft: '5%' }}
          >
            <Col
              md="3"
              sm="12"
            >
              <Label className="me-1">Tipo de documento</Label>
              <Controller
                name="codeType"
                control={control}
                render={({ field }) => (
                  <Select
                    options={[
                      { value: 'dui', label: 'DUI' },
                      { value: 'nit', label: 'NIT' },
                    ]}
                    value={
                      filterProps.codeType
                        ? {
                            value: filterProps.codeType,
                            label:
                              filterProps.codeType === 'dui'
                                ? 'DUI'
                                : 'NIT',
                          }
                        : null
                    }
                    onChange={(e) => {
                      setFilterProps({ ...filterProps, codeType: e.value })
                      setValue('clientCode', '')
                    }}
                  />
                )}
              />
            </Col>
            <Col
              md="4"
              sm="12"
            >
              <InputNumber
                label={'N° Documento'}
                errors={errors}
                control={control}
                disabled={!filterProps.codeType}
                options={{
                  id: 'clientCode',
                  name: 'clientCode',
                  startWithCero: true,
                  maxLength: filterProps.codeType === 'dui' ? 9 : 14,
                }}
              />
            </Col>
            <Col
              md="3"
              sm="12"
            >
              <InputPhone
                label={'N° celular'}
                errors={errors}
                control={control}
                options={{
                  id: 'receiverPhoneNumber',
                  name: 'receiverPhoneNumber',
                }}
              />
            </Col>
          </Row>
          <Row
            className="mx-0"
            style={{ paddingLeft: '5%' }}
          >
            <Col
              md="5"
              sm="12"
            >
              <Label
                className="me-1"
                for="search-input"
              >
                Desde
              </Label>
              <div className="mb-50">
                <ResponsiveDatePickers
                  value={filterProps.startDate}
                  onChange={(date) =>
                    setFilterProps({ ...filterProps, startDate: date })
                  }
                  disableFuture
                  Label=""
                  placeholder="Selecciona una fecha"
                  datePickerHeight="0px"
                />
              </div>
            </Col>

            <Col
              md="5"
              sm="12"
            >
              <Label
                className="me-1"
                for="search-input"
              >
                Hasta
              </Label>
              <div className="mb-50">
                <ResponsiveDatePickers
                  value={filterProps.endDate}
                  onChange={(date) =>
                    setFilterProps({ ...filterProps, endDate: date })
                  }
                  disableFuture
                  Label=""
                  placeholder="Selecciona una fecha"
                  datePickerHeight="0px"
                />
              </div>
            </Col>
          </Row>

          <Row>
            <Col className="d-flex align-items-center justify-content-sm-center mx-2 my-3">
              <Button
                className="mx-2"
                style={{ size: '10px', width: '200px' }}
                color="primary"
                type="submit"
                disabled={isPending}
                // onClick={() => onFilter(filterProps)}
              >
                Búsqueda
              </Button>
              <Button
                className="mx-2"
                style={{ size: '10px', width: '200px' }}
                color="primary"
                type="reset"
                onClick={handleClearFilters}
              >
                Limpiar Filtros
              </Button>
            </Col>
          </Row>
        </Card>
      </Form>
    </Fragment>
  )
}

export default InvoicesFilter
